// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Fp-z","badgeLink":"Gp-z","category":"Hp-z"};